/// <reference path='../_references.ts'/>

module App.History {
	angular
		.module('history', [])
		.config([
			'$stateProvider',
			($stateProvider: ng.ui.IStateProvider) => {
				$stateProvider
					.state('zipSolutions.history', {
						url: 'history',
						data: {
							title: 'History',
						},
						views: {
							'content@': {
								controller: 'HistoryController',
								controllerAs: 'ctrl',
								templateUrl: 'html/history/history.html',
							},
						},
					})
					.state('zipSolutions.history.recommendations', {
						url: '/recommendations',
						data: {
							title: 'Recommendations History'
						},
						views: {
							'content@': {
								controller: 'RecommendationsListController',
								controllerAs: 'ctrl',
								templateUrl: 'html/history/recommendations/recommendations-list.html'
							}
						}
					})
					.state('zipSolutions.history.recommendations.detail', {
						url: '/:id',
						data: {
							title: 'Recommendations'
						},
						views: {
							'content@': {
								controller: 'RecommendationsDetailController',
								controllerAs: 'workOrder',
								templateUrl: 'html/history/recommendations/recommendations-detail.html'
							}
						}
					})
					.state('zipSolutions.history.recommendations.detail.preview', {
						url: '/view',
						data: {
							title: 'Recommendation Preview'
						},
						views: {
							'content@': {
								controller: 'RecommendationsViewController',
								controllerAs: 'ctrl',
								templateUrl: 'html/history/recommendations/recommendations-view.html'
							}
						}
					})
					.state('zipSolutions.history.servicerequest', {
						url: '/service-requests',
						data: {
							title: 'Service Request History'
						},
						views: {
							'content@': {
								controller: 'ServiceRequestListController',
								controllerAs: 'ctrl',
								templateUrl: 'html/history/service-request-history/service-request-list.html'
							}
						}
					})
					.state('zipSolutions.history.servicerequest.detail', {
						url: '/:id',
						data: {
							title: 'Service Request'
						},
						views: {
							'content@': {
								controller: 'ServiceRequestDetailController',
								controllerAs: 'ctrl',
								templateUrl: 'html/history/service-request-history/service-request-detail.html'
							}
						}
					})
					.state('zipSolutions.history.photos', {
						url: '/photos',
						data: {
							title: 'Photos History'
						},
						views: {
							'content@': {
								controller: 'PhotosController',
								controllerAs: 'ctrl',
								templateUrl: 'html/history/photos/photos.html'
							}
						}
					})
					.state('zipSolutions.history.address', {
						url: '/:addressId',
						data: {
							title: 'Address History'
						},
						views: {
							'content@': {
								controller: 'HistoryController',
								controllerAs: 'ctrl',
								templateUrl: 'html/history/history.html'
							}
						}
					})
					.state('zipSolutions.history.address.recommendations', {
						url: '/recommendations',
						data: {
							title: 'Address Recommendations History'
						},
						views: {
							'content@': {
								controller: 'RecommendationsListController',
								controllerAs: 'ctrl',
								templateUrl: 'html/history/recommendations/recommendations-list.html'
							}
						}
					})
					.state('zipSolutions.history.address.servicerequests', {
						url: '/service-requests',
						data: {
							title: 'Address Service Request History'
						},
						views: {
							'content@': {
								controller: 'ServiceRequestListController',
								controllerAs: 'ctrl',
								templateUrl: 'html/history/service-request-history/service-request-list.html'
							}
						}
					})
					.state('zipSolutions.history.address.photos', {
						url: '/photos',
						data: {
							title: 'Address Photos History'
						},
						views: {
							'content@': {
								controller: 'PhotosController',
								controllerAs: 'ctrl',
								templateUrl: 'html/history/photos/photos.html'
							}
						}
					});
			}
	]).service('HistoryService', HistoryService.Factory())
		.controller('HistoryController', HistoryController)
		.controller('ServiceRequestListController', ServiceRequestListController)
		.controller('ServiceRequestDetailController', ServiceRequestDetailController)
		.controller('RecommendationsListController', RecommendationsListController)
		.controller('RecommendationsDetailController', RecommendationsDetailController)
		.controller('RecommendationsViewController', RecommendationsViewController)
		.controller('PhotosController', PhotosController);
}